import React, { useEffect, useState } from "react";
import { FaPlus, FaEye, FaTrashAlt, FaSearch } from "react-icons/fa";
import Input from "../../Components/Input/Input";
import AuthButton from "../../Components/AuthButton/AuthButton";
import { RiAlertFill } from "react-icons/ri";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { IoClose } from "react-icons/io5";
import { BsCalendar3 } from "react-icons/bs";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  addLead,
  deleteLead,
  getLeadbyid,
  getLead,
  getEmployees,
  updateLead,
  LeadById,
  addLeadData,
} from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import { MdEdit } from "react-icons/md";
import CreateAccountModal from "../../Components/CreateAccount/CreateAccount";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import { subscriptionsCondition } from "../../Reducers/reducers";
import { toast } from "react-toastify";
import CustomToast from "../../Components/CustomToast/CustomToast";
import GoogleMapsWrapper from "../../Components/Input/AddressInput";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import moment from "moment";
export default function LeadManagementScreen() {
  const { loginData, leadsData, loader, employeesData, Privilages } = useSelector((state) => state.userReducer);
  const [searchQuery, setSearchQuery] = useState("");
  const [leadStatusFilter, setLeadStatusFilter] = useState("");
  const [leadSourceFilter, setLeadSourceFilter] = useState("");
  const [salesRepFilter, setSalesRepFilter] = useState("");
  const [selectedLead, setSelectedLead] = useState(null);
  const [isaccountModalOpen, setIsaccountModalOpen] = useState(false);
  const dispatch = useDispatch();
  const getLeaddata = () => {
    dispatch(getLead(loginData?.accessToken));
  };
  useEffect(() => {
    getLeaddata();
  }, []);

  useEffect(() => {
    setLeads(leadsData);
  }, [leadsData]);

  const [leads, setLeads] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [deleteid, setdeleteid] = useState("");
  const [leadId, setIdLead] = useState("");
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDelete = (id) => {
    setdeleteid(id);
    setIsDeleteModalOpen(true);
  };
  const confirmDelete = () => {
    dispatch(
      deleteLead(loginData?.accessToken, deleteid, () => {
        getLeaddata();
        setIsDeleteModalOpen(false);
      })
    );
  };
  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };

  const leadStatusOptions = [
    { label: "All", value: "" },
    { label: "Contacted", value: "Contacted" },
    { label: "Follow up", value: "Follow up" },
    { label: "Under Negotiations", value: "Under Negotiations" },
    { label: "Quotation sent", value: "Quotation sent" },
    {
      label: "Master Agreement negotiations",
      value: "Master Agreement negotiations",
    },
    {
      label: "Account Opening in process",
      value: "Account Opening in process",
    },
    { label: "Account converted", value: "Account converted" },
    { label: "Awaiting LPO/LPO Received", value: "Awaiting LPO/LPO Received" },
    { label: "Pending Delivery", value: "Pending Delivery" },
    {
      label: "Received Confirmation of Execution",
      value: "Received Confirmation of Execution",
    },
  ];

  const leadSourceOptions = [
    { label: "All", value: "" },
    { label: "Cold Call", value: "Cold Call" },
    { label: "Referral", value: "Referral" },
    { label: "Social Media", value: "Social Media" },
    {
      label: "Subsidiary of Existing Customer",
      value: "Subsidiary of Existing Customer",
    },
    { label: "Generated by Marketing", value: "Generated by Marketing" },
    {
      label: "Dormant Account reactivated",
      value: "Dormant Account reactivated",
    },
    { label: "Others", value: "Others" },
  ];

  const salesRepOptions = [
    { value: "", label: "All" },
    ...employeesData?.map((source) => ({
      value: source.id,
      label: source.FullName,
    })),
  ];

  const selectedLeadStatus = leadStatusOptions?.find((option) => option.value === leadStatusFilter);
  const selectedLeadSource = leadSourceOptions?.find((option) => option.value === leadSourceFilter);
  const selectedSalesRep = salesRepOptions?.find((option) => option.value === salesRepFilter);

  const handleEdit = (lead) => {
    dispatch(getLeadbyid(loginData?.accessToken, lead.id));
    dispatch(getEmployees(loginData?.accessToken, true));
    setIsDetailModalOpen(true);
  };
  const filteredLeads = leads.filter((lead) => {
    console.log(lead.salesRep.FullName, "pp", salesRepFilter);
    return (
      lead?.leadName?.toLowerCase().includes(searchQuery?.toLowerCase()) &&
      (leadStatusFilter === "" || lead.status === leadStatusFilter) &&
      (leadSourceFilter === "" || lead.leadSource === leadSourceFilter) &&
      (salesRepFilter === "" || lead.salesRep.id === salesRepFilter)
    );
  });

  const getStatusStyle = (status) => {
    if (status.includes("Converted")) return "bg-green-100 text-green-700";
    if (status.includes("Create")) return "bg-yellow-100 text-yellow-700";
    return "bg-gray-100 text-gray-700";
  };
  const [width, setWidth] = useState(getWidthByBreakpoint());

  function getWidthByBreakpoint() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 640) {
      // sm
      return screenWidth;
    } else if (screenWidth < 768) {
      // md
      return screenWidth - 60;
    } else {
      // 2xl and above
      return screenWidth - 320;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidthByBreakpoint());
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // call once on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const PrivilagesArray = Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "Lead Management") : [];
  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == "Full Access" ? true : false) : true
        }
        buttonText="Add New Lead"
        buttonIcon={<FaPlus className="mr-2" />}
        onButtonClick={() => {
          subscriptionsCondition(
            loginData?.clientData?.subscriptionType,
            () => {
              if (leadsData?.length >= 20) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 20 leads allowed.Change Plan for creating more leads."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              if (leadsData?.length >= 200) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 200 leads allowed.Change Plan for creating more leads."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                setisEdit(false);
                setIsModalOpen(true);
              }
            },
            () => {
              setisEdit(false);
              setIsModalOpen(true);
            }
          );
        }}
      />
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className=" bg-white rounded-t-lg py-4 flex md:flex-row sm:flex-col space-y-4 sm:space-y-0 sm:space-x-0 md:space-x-2 items-center self-center">
            <div className="relative md:w-2/6 sm:w-full mb-[15px] md:mb-0">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearch}
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
              />
            </div>

            <div className="md:mt-0 md:w-4/6 sm:w-full flex sm:flex-row sm:space-x-2 space-y-4 sm:space-y-0">
              {/* <select
                className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-2/6"
                value={leadStatusFilter}
                onChange={(e) => setLeadStatusFilter(e.target.value)}
              >
                <option value="">Lead status</option>
                <option value="Converted to account by sales rep">
                  Converted
                </option>
                <option value="Create an account for this lead">
                  Create an account
                </option>
              </select>
              <select
                className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-2/6"
                value={leadSourceFilter}
                onChange={(e) => setLeadSourceFilter(e.target.value)}
              >
                <option value="">Lead Source</option>
                <option value="Referral">Referral</option>
                <option value="Website">Website</option>
                <option value="Social Media">Social Media</option>
              </select>
              <select
                className="border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-2/6"
                value={salesRepFilter}
                onChange={(e) => setSalesRepFilter(e.target.value)}
              >
                <option value="">Assigned Sales Rep</option>
                <option value="Jane Smith">Jane Smith</option>
                <option value="John Smith">John Smith</option>
              </select> */}

              <DropDownCustom
                isAligned={true}
                selectedValue={selectedLeadStatus}
                handleChanges={(option) => handleChanges(option, setLeadStatusFilter)}
                options={leadStatusOptions}
                isSearchable={false}
                label="Lead Status"
                placeholder="Lead Status"
              />
              <DropDownCustom
                selectedValue={selectedLeadSource}
                handleChanges={(option) => handleChanges(option, setLeadSourceFilter)}
                options={leadSourceOptions}
                isSearchable={false}
                label="Lead Source"
                placeholder="Lead Source"
                isAligned={true}
              />
              <DropDownCustom
                selectedValue={selectedSalesRep}
                handleChanges={(option) => handleChanges(option, setSalesRepFilter)}
                options={salesRepOptions}
                isSearchable={false}
                label="Assigned Sales Rep"
                placeholder="Sales Rep"
                isAligned={true}
              />
            </div>
          </div>
          <div style={{ width: width < 640 ? "100%" : `${width}px` }}>
            <div className="overflow-x-auto bg-white shadow-md rounded-lg overflow-hidden">
              <div className="bg-white  rounded-lg">
                <table className="min-w-full text-left">
                  <thead className="bg-[#361D3214]">
                    <tr className="text-gray-500 text-sm">
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm  min-w-[150px]">Lead Name</th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[120px]">Email</th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[150px]">Phone Number</th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[140px]">Sales Rep</th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm  min-w-[120px]">Lead Source</th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[270px] text-center">
                        Status
                      </th>
                      <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[120px] text-center">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="text-sm text-gray-800">
                    {filteredLeads?.length > 0 ? (
                      filteredLeads.map((lead) => (
                        <tr key={lead.id} className="border-t">
                          <td className="px-4 py-3">{lead.leadName || ""}</td>
                          <td className="px-4 py-3">{lead.email || ""}</td>
                          <td className="px-4 py-3">{lead.countryCode + lead.phoneNumber || ""}</td>
                          <td className="px-4 py-3">{lead?.salesRep?.FullName || ""}</td>
                          <td className="px-4 py-3">{lead.leadSource || ""}</td>

                          <td className="px-4 py-3 text-center">
                            <span
                              style={{
                                background:
                                  lead.status === "Account converted"
                                    ? "#22C55E29"
                                    : lead.status === "Pending with Admin"
                                    ? "#FFAB0029"
                                    : "#e5e7eb",
                                color:
                                  lead.status === "Account converted"
                                    ? "#118D57"
                                    : lead.status === "Pending with Admin"
                                    ? "#B76E00"
                                    : "#374151",
                              }}
                              className={`px-3 py-1 rounded font-semibold text-xs ${
                                lead.status === "Pending with Admin" ? "cursor-pointer" : ""
                              } ${getStatusStyle(lead.status)}`}
                              onClick={() => {
                                if (lead.status === "Pending with Admin") {
                                  setIdLead(lead?.id);
                                  setSelectedLead(lead);
                                  setIsaccountModalOpen(true);
                                }
                              }}
                            >
                              {lead.status === "Account converted"
                                ? "Converted to account"
                                : lead.status === "Pending with Admin"
                                ? "Create an account for this lead"
                                : lead.status}
                            </span>
                          </td>
                          <td className="px-4 py-3 flex space-x-2 justify-center ">
                            <button
                              className="text-gray-600 hover:text-blue-500 bg-gray-100 p-2 rounded-full"
                              onClick={() => {
                                handleEdit(lead);
                              }}
                            >
                              <FaEye />
                            </button>
                            {PrivilagesArray?.length > 0 ? (
                              PrivilagesArray[0].accessLevel === "Full Access" ? (
                                <button
                                  className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                                  onClick={() => handleDelete(lead.id)}
                                >
                                  <FaTrashAlt />
                                </button>
                              ) : null
                            ) : (
                              <button
                                className="text-gray-600 hover:text-red-500 bg-gray-100 p-2 rounded-full"
                                onClick={() => handleDelete(lead.id)}
                              >
                                <FaTrashAlt />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-gray-500 py-4">
                          No lead found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <AddLeadModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={() => {
              getLeaddata();
            }}
          />
          <LeadDetailsModal
            isOpen={isDetailModalOpen}
            onClose={() => setIsDetailModalOpen(false)}
            leadData={selectedLead}
            PrivilagesCondition={
              PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel !== "View Only" ? true : false) : true
            }
            onConfirm={() => {
              getLeaddata();
            }}
          />
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(false)}
            onConfirm={confirmDelete}
          />
        </>
      )}
      <CreateAccountModal
        onHit={() => {
          getLeaddata();
        }}
        id={leadId}
        lead={selectedLead}
        isOpen={isaccountModalOpen}
        onClose={() => {
          setIsaccountModalOpen(false);
          setSelectedLead(null);
        }}
      />
    </ParentComponent>
  );
}

const AddLeadModal = ({ isOpen, onClose, onConfirm }) => {
  const [step, setStep] = useState(1);
  const staticLeadSource = [
    { label: "Cold Call", value: "Cold Call" },
    { label: "Referral", value: "Referral" },
    { label: "Social Media", value: "Social Media" },
    {
      label: "Subsidiary of Existing Customer",
      value: "Subsidiary of Existing Customer",
    },
    { label: "Generated by Marketing", value: "Generated by Marketing" },
    {
      label: "Dormant Account reactivated",
      value: "Dormant Account reactivated",
    },
    { label: "Others", value: "Others" },
  ];

  const accountTypeOptions = [
    {
      label: "New Account",
      value: "New",
    },
    {
      label: "Existing Account",
      value: "Existing",
    },
  ];

  const vehicleTypes = [
    { label: "Car", value: "Car" },
    { label: "Motorbike", value: "Motorbike" },
    { label: "Sedan", value: "Sedan" },
    { label: "Scooter", value: "Scooter" },
    { label: "Truck", value: "Truck" },
    { label: "Van", value: "Van" },
    { label: "Bicycle", value: "Bicycle" },
    { label: "Bus", value: "Bus" },
    { label: "Pickup", value: "Pickup" },
    { label: "Electric Scooter", value: "Electric Scooter" },
    { label: "SUV", value: "SUV" },
    { label: "Jeep", value: "Jeep" },
    { label: "Trailer", value: "Trailer" },
  ];

  const contractType = [
    { label: "Monthly", value: "Monthly" },
    { label: "Yearly", value: "Yearly" },
  ];
  const fleetType = [
    { label: "Commercial", value: "Commercial" },
    { label: "Non Commercial", value: "Non Commercial" },
    { label: "Both", value: "Both" },
  ];

  const [leadInfo, setLeadInfo] = useState({
    leadName: "",
    accountType: "",
    email: "",
    companyName: "",
    companyBackground: "",
    phoneNumber: "",
    leadSource: "",
    address: "",
    fleetType: "",
    fleetSize: "",
    competitorName: "",
    expectedMaturity: "",
    timeline: "",
    leadBudget: "",
    assignedTo: 0,
    notes: "",
    status: "",
    countryCode: "+971",
    contractType: "",
    noOfUnits: "",
    tenure: "",
    vehicleType: "",
    reasonForOffHire: "",
  });
  const [errors, setErrors] = useState({});
  console.log(leadInfo, "OOOO");
  const { employeesData, loginData, subLoader } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const validateForm = () => {
    let newErrors = {};
    if (step == 1) {
      if (!leadInfo.leadName) {
        newErrors.leadName = "Lead Name is required";
      }
      if (!leadInfo.accountType) {
        newErrors.accountType = "Account type is required";
      }
      if (!leadInfo.email) {
        newErrors.email = "Email is required";
      }
      if (!leadInfo.companyName) {
        newErrors.companyName = "Company Name is required";
      }
      if (!leadInfo.companyBackground) {
        newErrors.companyBackground = "Company Background is required";
      }
      if (!leadInfo.phoneNumber) {
        newErrors.phoneNumber = "Phone Number Activity";
      }
      if (!leadInfo.leadSource) {
        newErrors.leadSource = "Lead Source is required";
      }
      if (!leadInfo.address) {
        newErrors.address = "Address is required";
      }
      if (!leadInfo.fleetType) {
        newErrors.fleetType = "Fleet Type is required";
      }

      if (!leadInfo.fleetSize) {
        newErrors.fleetSize = "Fleet Size is required";
      }
      if (!leadInfo.competitorName) {
        newErrors.competitorName = "Competitor Name is required";
      }
      if (!leadInfo.expectedMaturity) {
        newErrors.expectedMaturity = "Expected Maturity is required";
      }
      if (!leadInfo.timeline) {
        newErrors.timeline = "Delivery Timeline is required";
      }
      if (!leadInfo.leadBudget) {
        newErrors.leadBudget = "Lead Budget is required";
      }
      if (!leadInfo.vehicleType) {
        newErrors.vehicleType = "Vehicle Type is required";
      }
      if (!leadInfo.contractType) {
        newErrors.contractType = "Contract Type is required";
      }
      if (!leadInfo.noOfUnits) {
        newErrors.noOfUnits = "No Of Units is required";
      }
      if (!leadInfo.tenure) {
        newErrors.tenure = "Tenure is required";
      }
      if (!leadInfo.reasonForOffHire) {
        newErrors.reasonForOffHire = "Reason For Off Hire is required";
      }
    }
    if (step == 2) {
      if (leadInfo.assignedTo == 0) {
        newErrors.assignedTo = "Sales Representative is required";
      }
      if (!leadInfo.notes) {
        newErrors.notes = "Notes is required";
      }
      if (!leadInfo.status) {
        newErrors.status = "Lead Status is required";
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors)?.length === 0;
  };
  if (!isOpen) return null;

  const handleNextStep = () => {
    if (validateForm()) {
      setStep((prev) => prev + 1);
    }
  };

  const handlePrevStep = () => {
    setStep(step - 1);
  };

  const handleInputChange = (field, value) => {
    setLeadInfo((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  const handleSubmit = () => {
    if (validateForm()) {
      dispatch(
        addLeadData(leadInfo, loginData?.accessToken, () => {
          onClose();
          onConfirm();
          setStep(1);
        })
      );
    }
  };
  const handleChanges = (field) => (selectedOption) => {
    handleInputChange(field, selectedOption.value);
  };
  const leadSourceOptions = staticLeadSource?.map((source) => ({
    value: source.value,
    label: source.label,
  }));

  const salesRepOptions = employeesData?.map((source) => ({
    value: source.id,
    label: source.FullName,
  }));
  const selectedLeadSource = leadSourceOptions?.find((option) => option.value === leadInfo.leadSource);
  const selectedAccountType = accountTypeOptions?.find((option) => option.value === leadInfo.accountType);
  const selectedVehicleType = vehicleTypes?.find((option) => option.value === leadInfo.vehicleType);
  const selectedContractType = contractType?.find((option) => option.value === leadInfo.contractType);
  const selectedFleetType = fleetType?.find((option) => option.value === leadInfo.fleetType);
  const selectedSalesRep = salesRepOptions?.find((option) => option.value === leadInfo.assignedTo);

  return step === 1 ? (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
        <div onClick={onClose} className="bg-gray-800 opacity-50 fixed inset-0"></div>
        <div className="bg-white rounded-lg shadow-lg px-4 pt-4 w-[95%] md:w-[60%] relative">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold">Add New Lead</h2>
            <button onClick={onClose} className="top-3 right-3 text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>

          <div className="flex items-center mb-6 w-[70%] pl-[22.5%]">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                step >= 1 ? "bg-[#361D32] text-white" : "bg-gray-300"
              }`}
            >
              1
            </div>
            <div className={`flex-1 border-t-2 ${step >= 1 ? "border-[#361D32]" : "border-gray-300"}`}></div>
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                step >= 2 ? "bg-[#361D32] text-white" : "bg-gray-300"
              }`}
            >
              2
            </div>
          </div>

          <div className="flex justify-between mb-4 w-[75%] pl-[17.5%]">
            <p className="text-sm font-medium text-[#361D32]">Lead Information</p>
            <p className="text-sm font-medium text-gray-400">Lead Assignment</p>
          </div>

          <div className="space-y-4 overflow-y-auto h-[50vh] pt-2">
            <Input
              type="text"
              label={"Lead Name*"}
              float
              placeholder="Lead name"
              value={leadInfo.leadName}
              onChange={(e) => handleInputChange("leadName", e.target.value)}
              error={errors.leadName}
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="mt-[-21px]">
                <DropDownCustom
                  selectedValue={selectedAccountType}
                  handleChanges={handleChanges("accountType")}
                  options={accountTypeOptions}
                  isSearchable={false}
                  label="Account Type*"
                  placeholder="Select Account Type"
                />
                {errors.accountType && <p className="text-red-500 text-sm">{errors.accountType}</p>}
              </div>
              <Input
                type="email"
                placeholder="Email Address"
                label={"Email Address*"}
                float={true}
                value={leadInfo.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
                error={errors.email}
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input
                type="text"
                placeholder="Company Name"
                float={true}
                label={"Company Name*"}
                value={leadInfo.companyName}
                onChange={(e) => handleInputChange("companyName", e.target.value)}
                error={errors.companyName}
              />
              <Input
                type="text"
                placeholder="Company Background"
                float={true}
                label={"Company Background*"}
                value={leadInfo.companyBackground}
                onChange={(e) => handleInputChange("companyBackground", e.target.value)}
                error={errors.companyBackground}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input
                isPhoneNumber
                countryCodeValue={leadInfo?.countryCode}
                onCountryChange={(newCountryCode) => {
                  setLeadInfo((prev) => ({
                    ...prev,
                    countryCode: newCountryCode,
                  }));
                }}
                float={true}
                placeholder="Phone Number"
                label={"Phone Number*"}
                value={leadInfo.phoneNumber}
                onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
                error={errors.phoneNumber}
              />
              {/* <div>
                <div className="relative top-3 left-4 bg-white px-1 w-[150px] mt-[-25px]">
                  <label className="text-sm font-medium text-gray-600">
                    Lead Source
                  </label>
                </div>
                <select
                  className="block w-full p-3 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400"
                  value={leadInfo.leadSource}
                  onChange={(e) =>
                    handleInputChange("leadSource", e.target.value)
                  }
                >
                  {staticLeadSource.map((source) => (
                    <option key={source.value} value={source.value}>
                      {source.label}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="mt-[-21px]">
                <DropDownCustom
                  selectedValue={selectedLeadSource}
                  handleChanges={handleChanges("leadSource")}
                  options={leadSourceOptions}
                  isSearchable={false}
                  label="Lead Source*"
                  placeholder="Select Lead Source"
                />
                {errors.leadSource && <p className="text-red-500 text-sm">{errors.leadSource}</p>}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="mt-[-21px]">
                <DropDownCustom
                  selectedValue={selectedVehicleType}
                  handleChanges={handleChanges("vehicleType")}
                  options={vehicleTypes}
                  isSearchable={false}
                  label="Vehicle Type*"
                  placeholder="Select Vehicle Type"
                />
                {errors.vehicleType && <p className="text-red-500 text-sm">{errors.vehicleType}</p>}
              </div>
              <div className="mt-[-21px]">
                <DropDownCustom
                  selectedValue={selectedContractType}
                  handleChanges={handleChanges("contractType")}
                  options={contractType}
                  isSearchable={false}
                  label="Contract Type*"
                  placeholder="Select Contract Type"
                />
                {errors.contractType && <p className="text-red-500 text-sm">{errors.contractType}</p>}
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input
                type="text"
                placeholder="No of Units"
                label={"No of Units*"}
                float={true}
                value={leadInfo.noOfUnits}
                onChange={(e) => handleInputChange("noOfUnits", e.target.value)}
                error={errors.noOfUnits}
              />
              <Input
                type="text"
                placeholder="Tenure"
                label={"Tenure*"}
                float={true}
                value={leadInfo.tenure}
                onChange={(e) => handleInputChange("tenure", e.target.value)}
                error={errors.tenure}
              />
            </div>

            <Input
              type="text"
              placeholder="Reason"
              label={"Reason for Off Hire*"}
              float={true}
              value={leadInfo.reasonForOffHire}
              onChange={(e) => handleInputChange("reasonForOffHire", e.target.value)}
              error={errors.reasonForOffHire}
            />

            <GoogleMapsWrapper
              errors={errors}
              setErrors={setErrors}
              formData={leadInfo}
              setFormData={setLeadInfo}
              which={true}
            />
            {/* <Input
              type="text"
              placeholder="Address"
              label={"Address"}
              float={true}
              value={leadInfo.address}
              onChange={(e) => handleInputChange("address", e.target.value)}
              error={errors.address}
            /> */}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="mt-[-21px]">
                <DropDownCustom
                  selectedValue={selectedFleetType}
                  handleChanges={handleChanges("fleetType")}
                  options={fleetType}
                  isSearchable={false}
                  label="Fleet Type*"
                  placeholder="Fleet Type"
                />
                {errors.fleetType && <p className="text-red-500 text-sm">{errors.fleetType}</p>}
              </div>
              {/* <Input
                type="text"
                placeholder="Fleet Type"
                label={"Fleet Type"}
                float={true}
                value={leadInfo.fleetType}
                onChange={(e) => handleInputChange("fleetType", e.target.value)}
                error={errors.fleetType}
              /> */}
              <Input
                type="text"
                placeholder="Fleet Size"
                label={"Fleet Size*"}
                float={true}
                value={leadInfo.fleetSize}
                onChange={(e) => handleInputChange("fleetSize", e.target.value)}
                error={errors.fleetSize}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input
                type="text"
                placeholder="Competitor Name"
                float={true}
                label={"Competitor Name*"}
                value={leadInfo.competitorName}
                onChange={(e) => handleInputChange("competitorName", e.target.value)}
                error={errors.competitorName}
              />
              <Input
                type="date"
                placeholder=""
                float={true}
                label={"Expected Maturity*"}
                value={leadInfo.expectedMaturity}
                onChange={(e) => handleInputChange("expectedMaturity", e.target.value)}
                error={errors.expectedMaturity}
              />
            </div>

            <Input
              type="date"
              placeholder=""
              float={true}
              label={"Delivery Timeline*"}
              value={leadInfo.timeline}
              onChange={(e) => handleInputChange("timeline", e.target.value)}
              error={errors.timeline}
            />

            <Input
              type="text"
              placeholder="Lead Budget"
              label={"Lead Budget*"}
              float={true}
              value={leadInfo.leadBudget}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/, "");
                setLeadInfo({ ...leadInfo, leadBudget: numericValue });
                setErrors({ ...errors, leadBudget: "" });
              }}
              error={errors.leadBudget}
            />
          </div>

          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              onClick={onClose}
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
            />
            <AuthButton
              width={"20%"}
              title={"Save and Next"}
              onClick={handleNextStep}
              className="px-4 py-2 text-white rounded-md"
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4 w-full">
        <div onClick={onClose} className="bg-gray-800 opacity-50 fixed inset-0"></div>
        <div className="bg-white rounded-lg shadow-lg px-4 pt-4 w-[95%] md:w-[60%] relative  ">
          <div className="flex justify-between items-center  mb-6 test">
            <h2 className="text-xl font-semibold">Add New Lead</h2>
            <button onClick={onClose} className="top-3 right-3 text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>

          <div className="flex items-center mb-6 w-[70%] pl-[22.5%]">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                step >= 1 ? "bg-[#361D32] text-white" : "bg-gray-300"
              }`}
            >
              1
            </div>
            <div className={`flex-1 border-t-2 ${step >= 1 ? "border-[#361D32]" : "border-gray-300"}`}></div>
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                step >= 2 ? "bg-[#361D32] text-white" : "bg-gray-300"
              }`}
            >
              2
            </div>
          </div>

          <div className="flex justify-between mb-10 w-[75%] pl-[17.5%]">
            <p className="text-sm font-medium text-gray-400">Lead Information</p>
            <p className="text-sm font-medium text-[#361D32]">Lead Assignment</p>
          </div>

          <div className="space-y-4">
            {/* <div>
              <div className="relative top-3 left-4 bg-white px-1 w-[150px] mt-[-25px]">
                <label className="text-sm font-medium text-gray-600">
                  Assign to Sales Rep
                </label>
              </div>
              <select
                className="block w-full p-3 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400"
                value={leadInfo.assignedTo}
                onChange={(e) =>
                  handleInputChange("assignedTo", parseInt(e.target.value))
                }
              >
                {employeesData?.map((source) => (
                  <option key={source.id} value={source.id}>
                    {source.FullName}
                  </option>
                ))}
              </select>
            </div> */}
            <div>
              <DropDownCustom
                selectedValue={selectedSalesRep}
                handleChanges={handleChanges("assignedTo")}
                options={salesRepOptions}
                isSearchable={true}
                label="Assign to Sales Rep*"
                placeholder="Select Sales Rep"
              />
              {errors.assignedTo && <p className="text-red-500 text-sm">{errors.assignedTo}</p>}
            </div>
            <div className="">
              <CustomDropdown leadInfo={leadInfo} handleInputChange={handleInputChange} />
              {errors.status && <p className="text-red-500 text-sm">{errors.status}</p>}
              {/* <select
                className="block w-full p-3 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400"
                value={leadAssignment.status}
                onChange={(e) =>
                  handleAssignmentChange("status", e.target.value)
                }
              >
                <option value="Contacted">Cold Leads:</option>
                <option value="In Progress">Contacted</option>
                <option value="Negotiation">Follow up</option>
                <option value="Closed">Warm Leads:</option>
                <option value="In Progress">Under Negotiations</option>
                <option value="Negotiation">Quotation sent</option>
                <option value="In Progress">Master Agreement negotiations</option>
                <option value="Negotiation">Account Opening in process</option>
                <option value="Closed">Hot Leads:</option>
                <option value="In Progress">Account converted </option>
                <option value="Negotiation">Awaiting LPO/LPO Received</option>
                <option value="In Progress">Pending Delivery </option>
                <option value="Negotiation">Received Confirmation of Execution</option>

              </select> */}
            </div>
            <Input
              textarea={true}
              placeholder="Enter notes"
              label={"Notes*"}
              value={leadInfo.notes}
              onChange={(e) => handleInputChange("notes", e.target.value)}
              error={errors.notes}
            />
          </div>
          <div className="flex justify-end mt-6 space-x-4 mb-2">
            {subLoader ? (
              <Loader />
            ) : (
              <>
                <AuthButton
                  className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                  width={"20%"}
                  title={"Previous"}
                  onClick={handlePrevStep}
                />

                <AuthButton
                  width={"20%"}
                  title={"Save"}
                  className="px-4 py-2  text-white rounded-md"
                  onClick={handleSubmit}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export const LeadDetailsModal = ({ isOpen, onClose, leadData, onConfirm, PrivilagesCondition }) => {
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const { leadIdData, employeesData, loginData, subLoader } = useSelector((state) => state.userReducer);

  const [leadInfo, setLeadInfo] = useState({
    leadName: "",
    email: "",
    companyName: "",
    phoneNumber: "",
    leadSource: "",
    address: "",
    fleetType: "",
    fleetSize: "",
    competitorName: "",
    expectedMaturity: "",
    timeline: "",
    leadBudget: "",
    assignedTo: 0,
    notes: "",
    status: "",
    countryCode: "",
    contractType: "",
    noOfUnits: "",
    reasonForOffHire: "",
    tenure: "",
    vehicleType: "",
  });
  const [notes, setNotes] = useState([]);

  const [salesRep, setsalesRep] = useState("");
  useEffect(() => {
    if (leadIdData) {
      setLeadInfo({
        id: leadIdData.id,
        assignedTo: leadIdData?.salesRep?.id || "",
        leadName: leadIdData?.leadName || "",
        email: leadIdData?.email || "",
        accountType: leadIdData?.accountType || "",
        companyName: leadIdData?.companyName || "",
        phoneNumber: leadIdData?.phoneNumber || "",
        address: leadIdData?.address || "",
        fleetType: leadIdData?.fleetType || "",
        fleetSize: leadIdData?.fleetSize || "",
        competitorName: leadIdData?.competitorName || "",
        expectedMaturity: leadIdData?.expectedMaturity || "",
        timeline: leadIdData?.timeline || "",
        leadBudget: leadIdData?.leadBudget || "",
        notes: leadIdData?.notes || "",
        leadSource: leadIdData?.leadSource || "",
        status: leadIdData?.status || "",
        countryCode: leadIdData?.countryCode || "",
        contractType: leadIdData?.contractType || "",
        noOfUnits: leadIdData?.noOfUnits || "",
        reasonForOffHire: leadIdData?.reasonForOffHire || "",
        tenure: leadIdData?.tenure || "",
        vehicleType: leadIdData?.vehicleType || "",
      });
      setsalesRep(leadIdData?.salesRep?.FullName || "");
    } else {
      setLeadInfo({
        id: "",
        leadName: "",
        email: "",
        accountType: "",
        companyName: "",
        phoneNumber: "",
        leadSource: "",
        address: "",
        fleetType: "",
        fleetSize: "",
        competitorName: "",
        expectedMaturity: "",
        timeline: "",
        leadBudget: "",
        notes: "",
        leadSource: "",
        status: "",
        countryCode: "",
        contractType: "",
        noOfUnits: "",
        reasonForOffHire: "",
        tenure: "",
        vehicleType: "",
      });
    }
  }, [leadIdData]);

  useEffect(() => {
    if (leadInfo.id) {
      fetch(`${BaseUrl}/api/lead-notes/${leadInfo.id}`, {
        headers: {
          Authorization: `Bearer ${loginData?.accessToken}`,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res && res.data && res.data.notes.length > 0) {
            setNotes(res.data.notes);
          }
        });
    }
  }, [leadInfo, loginData]);

  useEffect(() => {
    if (!isOpen) {
      setNotes([]);
    }
  }, [isOpen]);

  if (!isOpen) return null;
  const handleSelectEmployee = (employee) => {
    setsalesRep(employee.FullName);
    setLeadInfo((prev) => ({
      ...prev,
      assignedTo: employee.id,
    }));
    setShowDropdown(false);
  };
  const HandleSave = () => {
    dispatch(
      updateLead(
        leadIdData?.id,
        leadInfo,
        loginData?.accessToken,
        () => {
          onConfirm();
          onClose();
        },
        () => {}
      )
    );
  };
  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 m-1  ">
        <div className="bg-gray-800 opacity-50 fixed inset-0"></div>

        <div className="bg-white rounded-lg shadow-lg pt-4 w-[95%] md:w-[60%] relative">
          <div className="flex justify-between items-center mb-6 px-4">
            <h2 className="text-xl font-semibold">Lead Details</h2>
            <button onClick={onClose} className="top-3 right-3 text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>
          <div className="overflow-auto max-h-[400px] px-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="space-y-2">
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Lead Name</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.leadName}</p>
                </div>
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Email Address</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.email}</p>
                </div>
                {!!leadInfo?.contractType && (
                  <div className="flex flex-row py-[10px] items-center ">
                    <p className="text-sm font-medium text-gray-600 w-[35%]">Contract Type</p>
                    <p className="text-sm font-medium text-black">{leadInfo?.contractType}</p>
                  </div>
                )}
                {!!leadInfo?.noOfUnits && (
                  <div className="flex flex-row py-[10px] items-center ">
                    <p className="text-sm font-medium text-gray-600 w-[35%]">No Of Units</p>
                    <p className="text-sm font-medium text-black">{leadInfo?.noOfUnits}</p>
                  </div>
                )}

                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%] sm:mr-2 md:mr-0">Lead Source</p>
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                    {leadInfo?.leadSource}
                  </span>
                </div>

                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Assigned To</p>
                  <div className="flex items-center space-x-2 relative">
                    {salesRep !== "" && (
                      <button className="flex flex-col items-center space-x-2   rounded-full px-3 py-1 ">
                        <span className="w-8 h-8 rounded-full bg-blue-500 text-white flex justify-center items-center text-md font-semibold shadow-sm">
                          {salesRep
                            ?.split(" ")
                            ?.map((n) => n[0])
                            ?.join("")}
                        </span>
                        <span className="text-gray-700 font-semibold text-xs">{salesRep?.split(" ")[0]}</span>
                      </button>
                    )}
                    {employeesData?.length > 0 && (
                      <button
                        className="w-10 h-10 rounded-full border-2 border-gray-300 flex justify-center items-center text-gray-500 text-xl"
                        onClick={() => setShowDropdown(!showDropdown)}
                      >
                        +
                      </button>
                    )}

                    {showDropdown && (
                      <div className="absolute top-12 left-0 bg-white border border-gray-300 rounded-lg shadow-lg w-52 py-2 z-10">
                        {employeesData?.map((data) => (
                          <button
                            key={data.id}
                            className="w-full flex items-center px-4 py-2 hover:bg-gray-100 transition duration-200 text-sm font-regular"
                            onClick={() => handleSelectEmployee(data)}
                          >
                            <span className="w-8 h-8 rounded-full bg-blue-500 text-white flex justify-center items-center text-sm font-semibold mr-3 shadow-sm">
                              {" "}
                              {data.FullName.split(" ")
                                .map((n) => n[0])
                                .join("")}
                            </span>
                            {data.FullName}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Company Name</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.companyName}</p>
                </div>
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Account Type</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.accountType}</p>
                </div>
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Company Background</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.companyBackground}</p>
                </div>
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Phone Number</p>
                  <p className="text-sm font-medium text-black">{leadInfo?.countryCode + leadInfo?.phoneNumber}</p>
                </div>
                {!!leadInfo?.tenure && (
                  <div className="flex flex-row py-[10px] items-center ">
                    <p className="text-sm font-medium text-gray-600 w-[35%]">Tenure</p>
                    <p className="text-sm font-medium text-black">{leadInfo?.tenure}</p>
                  </div>
                )}
                {!!leadInfo?.vehicleType && (
                  <div className="flex flex-row py-[10px] items-center ">
                    <p className="text-sm font-medium text-gray-600 w-[35%]">Vehicle Type</p>
                    <p className="text-sm font-medium text-black">{leadInfo?.vehicleType}</p>
                  </div>
                )}
                {!!leadInfo?.reasonForOffHire && (
                  <div className="flex flex-row py-[10px] items-center ">
                    <p className="text-sm font-medium text-gray-600 w-[35%]">Reason for OffHire</p>
                    <p className="text-sm font-medium text-black">{leadInfo?.reasonForOffHire}</p>
                  </div>
                )}
                <div className="flex flex-row py-[10px] items-center ">
                  <p className="text-sm font-medium text-gray-600 w-[35%]">Lead Status</p>
                  <span className="inline-block bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-medium">
                    {leadInfo?.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-row py-[10px] ">
              <p className="text-sm font-medium text-gray-600 w-[20%]">Description</p>
            </div>
            <Input
              textarea={true}
              value={leadInfo?.notes}
              onChange={(e) => {
                setLeadInfo({ ...leadInfo, notes: e.target.value });
              }}
            />
            <div className="flex flex-row justify-between items-center ">
              <p className="text-sm font-medium text-gray-600 w-[35%]">Expected Revenue</p>
              <p className="text-2xl font-semibold text-[#361D32]">AED {leadInfo?.leadBudget}</p>
            </div>
            <div className="w-full h-px border-t border-neutral-200 my-4" />
            {/* Notes */}
            {notes.length > 0 && (
              <div>
                <h2 className="text-sm font-medium text-gray-600 w-[35%]">Notes</h2>
                <ul className="mt-2">
                  {notes.map((item, index) => (
                    <li
                      key={index}
                      className=" flex items-center justify-between pb-4 mb-4 border-b last:border-none last:pb-0 last:mb-0"
                    >
                      <div className="flex items-center">
                        <div>
                          <p className="font-semibold text-sm">{item.employee.FullName}</p>
                          <p className="text-sm text-gray-500">{item.note}</p>
                        </div>
                      </div>
                      <p className="text-sm text-gray-500">{moment(item.createdAt).format("DD MMM YYYY")}</p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="flex justify-between items-center">
              <div></div>
              {subLoader ? (
                <div className="my-3">
                  <Loader />
                </div>
              ) : PrivilagesCondition ? (
                <div className="flex justify-end mt-6 space-x-4">
                  <AuthButton
                    className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                    width={"20%"}
                    title={"Cancel"}
                    onClick={onClose}
                  />

                  <AuthButton
                    width={"20%"}
                    title={"Save"}
                    className="px-4 py-2  text-white rounded-md"
                    onClick={HandleSave}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CustomDropdown = ({ leadInfo, handleInputChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(leadInfo.status);

  const options = [
    { label: "Cold Leads:", value: null, isHeader: true },
    { label: "Pending", value: "Pending" },
    { label: "Contacted", value: "Contacted" },
    { label: "Follow up", value: "Follow up" },
    { label: "Warm Leads:", value: null, isHeader: true },
    { label: "Under Negotiations", value: "Under Negotiations" },
    { label: "Quotation sent", value: "Quotation sent" },
    {
      label: "Master Agreement negotiations",
      value: "Master Agreement negotiations",
    },
    // {
    //   label: "Account Opening in process",
    //   value: "Account Opening in process",
    // },
    { label: "Hot Leads:", value: null, isHeader: true },
    // { label: "Account converted", value: "Account converted" },
    { label: "Awaiting LPO/LPO Received", value: "Awaiting LPO/LPO Received" },
    { label: "Pending Delivery", value: "Pending Delivery" },
    {
      label: "Received Confirmation of Execution",
      value: "Received Confirmation of Execution",
    },
  ];

  const handleSelect = (value) => {
    if (value) {
      setSelectedValue(value);
      handleInputChange("status", value);
      setIsOpen(false);
    }
  };

  return (
    <div className="relative w-full">
      <div className="relative top-3 left-4 bg-white px-1 w-[150px] mt-[-25px]">
        <label className="text-sm font-medium text-gray-600">Lead Status*</label>
      </div>
      <button
        className="block w-full p-3 border  border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:ring-5 text-left"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        {selectedValue || "Select Status"}
      </button>

      {isOpen && (
        <div className="absolute mt-2 w-full rounded-lg shadow-lg bg-white border border-gray-300 z-10 max-h-56 overflow-y-auto">
          {options.map((option, index) =>
            option.isHeader ? (
              <div key={index} className="px-4 py-2 font-bold text-gray-900 bg-gray-100 sticky top-0">
                {option.label}
              </div>
            ) : (
              <div
                key={index}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};
